import { render, staticRenderFns } from "./JiraNotificationStatus.vue?vue&type=template&id=83c1c21a&scoped=true&"
import script from "./JiraNotificationStatus.vue?vue&type=script&lang=js&"
export * from "./JiraNotificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./JiraNotificationStatus.vue?vue&type=style&index=0&id=83c1c21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c1c21a",
  null
  
)

export default component.exports